<script>
    import { createEventDispatcher } from 'svelte'
    import {people} from "../stores/people";
    import {companies} from "../stores/companies";
    import {person_company} from "../stores/person_company";
    import {people_search_list, additional_people_info, displayPersonFromID, bucketPeopleBySurname} from "../stores/misc.js";
    import {I_PERSON} from "../../../../../lib/datatypes.js";
    import {inArray} from "../../../../../lib/utils";
    import {navigateTo, PAGE_ID} from "../stores/router";
    import SearchBox from "./SearchBox.svelte";
    import BucketChooser from "./BucketChooser.svelte";

    const dispatch = createEventDispatcher();

    export let type = 'full';  // 'full' or 'box'
    export let selected_person_id = null;

    export let current_search_str = '';
    export let allow_adding_people = true;
    export let minimise_box_without_search = false;

    let person_buckets = {};
    let chosen_letter = '';

    $: searched_users = current_search_str === '' ? $people.list : $people_search_list.filter(entry => {
        return entry[0].includes(current_search_str.toLowerCase().replace(/\s+/g, ''));
    }).map(entry => {
        return $people.lookup[entry[1]];
        // return displayPersonFromID(entry[1]);
    });

    const MIN_PEOPLE_IN_SEARCH_TO_COLLAPSE = 50;
    const MAX_NUMBER_OPTIONS_IN_TYPE_BOX = 20;
    $: {
        // console.log(searched_users);
        // console.log('re-bucketing people as search string has changed')
        if(type === 'box' || searched_users.length < MIN_PEOPLE_IN_SEARCH_TO_COLLAPSE) {
            person_buckets = {
                'all': searched_users
            };
        }
        else {
            person_buckets = bucketPeopleBySurname(searched_users);
        }
        if(!inArray(Object.keys(person_buckets), chosen_letter)) chosen_letter = Object.keys(person_buckets)[0];
    }

    const onPersonClick = id => {
        dispatch('personClicked', {id: id});
    };
    const onCancelClick = () => {
        current_search_str = '';
        dispatch('cancelClicked');
    };
</script>

{#if type === "full"}
<div class="px-4 sm:px-6 lg:px-8">

    <div class="flex space-x-4">
        <SearchBox bind:current_search_str></SearchBox>
        <button type="submit" class="inline-flex justify-center rounded-md border border-gray-300 bg-white px-3.5 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2">
            <svg class="h-5 w-5 text-gray-400" x-description="Heroicon name: mini/funnel" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-5.757a2.25 2.25 0 00-.659-1.591L2.659 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z" clip-rule="evenodd"></path>
            </svg>
            <span class="sr-only">Search</span>
        </button>
    </div>

    <BucketChooser bind:person_buckets bind:chosen_letter></BucketChooser>

    <table class="min-w-full divide-y divide-gray-300">
        <thead>
        <tr>
            <th scope="col" class="py-3.5 pl-0 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Name</th>
            <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">Last Name</th>
            <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">Position</th>
            <th scope="col" class="relative py-3.5 pl-3 pr-0 text-left text-sm font-semibold text-gray-900 sm:pr-6">Company</th>
        </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
        <!-- TODO BUGFIX: am only rendering the first element in the companies/positions list.. there could be people with more than 1 -->
        {#each person_buckets[chosen_letter] as person (person[I_PERSON.ID])}
            <tr data-id="{person[I_PERSON.ID]}" on:click={() => onPersonClick(person[I_PERSON.ID])}
                class="cursor-pointer">
                <td class="w-full max-w-0 py-4 pl-0 pr-3 text-sm font-medium text-gray-900 align-top sm:w-auto sm:max-w-none sm:pl-6">
                    {person[I_PERSON.FIRST_NAME]} <span class="lg:hidden">{person[I_PERSON.LAST_NAME]}</span>
                    <dl class="font-normal sm:hidden">
                        <dt class="sr-only">Position</dt>
                        <dd class="mt-1 xtruncate text-gray-700">{$additional_people_info[person[I_PERSON.ID]][0].position}</dd>
                    </dl>
                </td>
                <td class="hidden px-3 py-4 text-sm font-medium text-gray-900 align-top lg:table-cell">{person[I_PERSON.LAST_NAME]}</td>
                <td class="hidden px-3 py-4 text-sm text-gray-500 align-top sm:table-cell">{$additional_people_info[person[I_PERSON.ID]][0].position}</td>
                <td class="py-4 pl-3 pr-6 text-sm text-gray-500 align-top sm:pr-0">{$additional_people_info[person[I_PERSON.ID]][0].company_name}</td>
            </tr>
        {/each}
        <!--{#each person_buckets[chosen_letter] as person (person.id)}-->
<!--            <tr data-id="{person.id}" on:click={() => onPersonClick(person.id)}>-->
<!--                <td class="w-full max-w-0 py-4 pl-0 pr-3 text-sm font-medium text-gray-900 align-top sm:w-auto sm:max-w-none sm:pl-6">-->
<!--                    {person.first_name} <span class="lg:hidden">{person.last_name}</span>-->
<!--                    <dl class="font-normal sm:hidden">-->
<!--                        <dt class="sr-only">Position</dt>-->
<!--                        <dd class="mt-1 xtruncate text-gray-700">{person.positions[0].position}</dd>-->
<!--                    </dl>-->
<!--                </td>-->
<!--                <td class="hidden px-3 py-4 text-sm font-medium text-gray-900 align-top lg:table-cell">{person.last_name}</td>-->
<!--                <td class="hidden px-3 py-4 text-sm text-gray-500 align-top sm:table-cell">{person.positions[0].position}</td>-->
<!--                <td class="py-4 pl-3 pr-6 text-sm text-gray-500 align-top sm:pr-0">{person.positions[0].company_name}</td>-->
<!--            </tr>-->
<!--        {/each}-->
        </tbody>
    </table>

</div>
{/if}
{#if type === 'box'}
    <div>
        <div class="relative mt-1 rounded-md shadow-sm">
            <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <svg class="h-5 w-5 text-gray-400" x-description="Heroicon name: mini/magnifying-glass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clip-rule="evenodd"></path>
                </svg>
            </div>
            <input bind:value={current_search_str} autofocus type="search" name="search" id="search" class="block w-full rounded-md border-gray-300 pl-10 focus:border-pink-500 focus:ring-pink-500 sm:text-sm" placeholder="Search">
        </div>
    </div>

    {#if (minimise_box_without_search && current_search_str !== '') || !minimise_box_without_search }

    <ol class="xabsolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base border border-gray-300 focus:outline-none sm:text-sm">
        {#each person_buckets[chosen_letter].slice(0, MAX_NUMBER_OPTIONS_IN_TYPE_BOX) as person (person[I_PERSON.ID])}
            <li data-id="{person[I_PERSON.ID]}" on:click={() => onPersonClick(person[I_PERSON.ID])}
                class="relative cursor-default select-none py-2 pl-8 pr-4 text-gray-900">
                {#if person[I_PERSON.ID] === selected_person_id}
                    <span class="block truncate font-semibold">{person[I_PERSON.FIRST_NAME]} {person[I_PERSON.LAST_NAME]}</span>
                    <span class="absolute inset-y-0 left-0 flex items-center pl-1.5 text-indigo-600">
                    <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                    </svg>
                </span>
                {:else}
                    <span class="block truncate">{person[I_PERSON.FIRST_NAME]} {person[I_PERSON.LAST_NAME]} - {$additional_people_info[person[I_PERSON.ID]][0].company_name}</span>
                {/if}
            </li>
        {/each}
    </ol>

    <div class="flex flex-shrink-0 justify-between mt-2">
        <button on:click={onCancelClick}
                type="button"
                class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >Cancel</button>
        {#if allow_adding_people}
        <button on:click={() => navigateTo(PAGE_ID.ADD_PERSON)}
                type="button" class="relative inline-flex items-center rounded-md border border-transparent bg-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800">
            <!-- Heroicon name: mini/plus -->
            <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
            </svg>
            <span>or.. Add A New Person</span>
        </button>
        {/if}
    </div>

    {/if}
{/if}

<style></style>